import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------

// POST =>  Add New School
export const addNewSchool = createAsyncThunk(
  "school/addNewSchool",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addNewSchoolURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get All Schools
export const getAllSchools = createAsyncThunk(
  "school/getAllSchools",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getAllSchoolsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get School Info
export const getSchoolInfo = createAsyncThunk(
  "school/getSchoolInfo",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.getSchoolInfoURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  Add New School
export const addImageToSchool = createAsyncThunk(
  "school/addImageToSchool",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addImageToSchoolURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  Edit School
export const editSchool = createAsyncThunk(
  "school/editSchool",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(
        `${URLS.editSchoolURL}/${params?.school_id}`,
        params?.data,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  Add New Secretary
export const AddNewSecretary = createAsyncThunk(
  "school/AddNewSecretary",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        URLS.AddNewSecretaryURL,
        data
        //   {
        //   headers: {
        //     Accept: "*/*",
        //     "Content-Type": "multipart/form-data",
        //   },
        // }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get School SecretaryAccounts
export const getSchoolSecretaryAccounts = createAsyncThunk(
  "school/getSchoolSecretaryAccounts",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.getSchoolSecretaryAccountsURL}/${id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
